import axiosClient from "../../api";

export interface OfficeValueModel {
  value: string;
}

export interface OfficeForumReferenceModel {
  id: number;
  code?: string;
  title: string;
  endDate: string;
  office: string;
}

export interface OfficeValueRequest {
  value: string;
}

export interface UpdateOfficeValueRequest {
  currentValue: string;
  value: string;
}

export interface OfficeUpdateResultModel {
  office: OfficeValueModel;
  updatedActiveForums: OfficeForumReferenceModel[];
}

const get = () => axiosClient.get<OfficeValueModel[]>("/offices");

const getActiveForumReferences = ({ value }: OfficeValueRequest) =>
  axiosClient.get<OfficeForumReferenceModel[]>("/offices/references", { params: { value } });

const post = ({ value }: OfficeValueRequest) => axiosClient.post<OfficeValueModel>("/offices", { value });

const put = ({ currentValue, value }: UpdateOfficeValueRequest) =>
  axiosClient.put<OfficeUpdateResultModel>("/offices", { currentValue, value });

const deleteOffice = ({ value }: OfficeValueRequest) => axiosClient.delete<void>("/offices", { params: { value } });

const Offices = {
  delete: deleteOffice,
  get,
  post,
  put,
  references: {
    get: getActiveForumReferences,
  },
};

export default Offices;
